module.exports = __webpack_public_path__ + "src/img/videoIcon.45f98b8d.svg";